import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export const Brc20Slice = createSlice({
  name: 'brc20',
  initialState: {
    balanceByBtc: {}
  },
  reducers: {
    setBalanceByBtc: (state, { payload } : PayloadAction<{[key:string]: string}>) => {
        state.balanceByBtc = payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { setBalanceByBtc } = Brc20Slice.actions

export default Brc20Slice.reducer